import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import SectionHeader from '../sectionHeader'
import SectionSubHeader from '../sectionSubHeader'

const TechAbility = () => {
  return (
    <div className='volto-section ' id='ability'>
          <Container>
          <SectionHeader mainText1={"Tech"} mainText2={"Ability"} />
          <SectionSubHeader headerText={"Technology Competence "} />

          <div className='tech-row'>
            <Row>
                <Col lg={12}>
                     <div className='tech-card-type'>
                        <Row>
                            <Col lg={3} >
                            
                            <h5><span>Digital</span> <span>Application</span></h5>
                            </Col>
                            <Col lg={9}>
                            <div className='tech-card-row'>
                        <div className='tech-card'>
                           <img src="/images/java-1.svg" alt="java" />
                            
                        </div>
                        <div className='tech-card'>
                           <img src="/images/react-1.svg" alt="react" />
                           
                        </div>
                        <div className='tech-card'>
                           <img src="/images/dotnet-1.svg" alt="dotnet" />
                            
                        </div>
                        <div className='tech-card'>
                           <img src="/images/angular-1.svg" alt="angular" />
                            
                        </div>
                        <div className='tech-card'>
                           <img src="/images/scala-1.svg" alt="scala" />
                           
                        </div>
                        </div>
                            </Col>
                        </Row>     
                     </div>
                     <div className='tech-card-type'>
                     <Row>
                        <Col lg={3}>
                      
                           <h5><span>Enterprise</span> <span>Apps</span></h5>
                            </Col>
                            <Col lg={9}>
                            <div className='tech-card-row'>
                        <div className='tech-card'>
                           <img src="/images/oracle-1.svg" alt="oracle" />
                           
                        </div>
                        <div className='tech-card'>
                           <img src="/images/ms365-1.svg" alt="dynamics" />
                           
                        </div>
                        <div className='tech-card'>
                           <img src="/images/sap-1.svg" alt="sap" />
                           
                        </div>
                        <div className='tech-card'>
                           <img src="/images/servicenow-1.svg" alt="servicesnow" />
                           
                        </div>
                        <div className='tech-card'>
                           <img src="/images/salesforce-1.svg" alt="salesforce" />
                          
                        </div>
                        </div>
                            </Col>
                     </Row>
                     </div>
                     <div className='tech-card-type'>
                     <Row>
                            <Col lg={3}>
                            
                            <h5><span>Infra and</span> <span>Security</span></h5>
                            </Col>
                            <Col lg={9}>

                            <div className='tech-card-row'>
                        <div className='tech-card'>
                           <img src="/images/docker-1.svg" alt="docker" />
                           
                        </div>
                        <div className='tech-card'>
                           <img src="/images/devops-1.svg" alt="devops" />
                            
                        </div>
                        <div className='tech-card'>
                           <img src="/images/infura-1.svg" alt="cloud-infura" />
                          
                        </div>
                       
                        </div>

                            </Col>
                        </Row> 
                        

                     </div>
                         
                     <div className='tech-card-type'>
                     <Row>
                        <Col lg={3}>
                        <h5><span>Cloud</span> <span>Technologies</span></h5>
                            </Col>
                            <Col lg={9}>
                            <div className='tech-card-row'>
                        <div className='tech-card'>
                           <img src="/images/amazon-1.svg" alt="aws" />
                           
                        </div>
                        <div className='tech-card'>
                           <img src="/images/azure-1.svg" alt="azure" />
                        
                        </div>
                        <div className='tech-card'>
                           <img src="/images/google-cloud.svg" alt="cloud-com" />
                            
                        </div>

                        </div>
                            </Col>
                     </Row>
                        
                    
                     </div>
                     <div className='tech-card-type'>

                     <Row>
                            <Col lg={3}>
                            
                            <h5><span>AI</span> <span>Solutions</span></h5>
                            </Col>
                            <Col lg={9}>

                            <div className='tech-card-row mb-lg-0'>
                        <div className='tech-card'>
                           <img src="/images/ai-dev-1.svg" alt="ai-dev" />
                            
                        </div>
                        <div className='tech-card'>
                           <img src="/images/ai-consult-1.svg" alt="java" />
                           
                        </div>
                        <div className='tech-card'>
                           <img src="/images/ai-interface-1.svg" alt="java" />
                            
                        </div>
                        </div>

                            </Col>
                        </Row> 
                         
                     
                     </div>
                
                </Col>
            </Row>

          </div>


          </Container>
      
    </div>
  )
}

export default TechAbility
